// Theme Configuration
// Add new themes here to make them available in the theme switcher

export const themes = {
  'wew-gold': {
    id: 'wew-gold',
    name: 'Gold Retro',
    description: 'Modern retro style with gold accents',
    bodyClass: 'wew-gold',
    colors: {
      primary: '#F5B81C',
      secondary: '#FFF8E7',
      accent: '#2D3748',
    }
  },
  'wew-class': {
    id: 'wew-class',
    name: 'Classic Blue',
    description: 'Classic blue theme',
    bodyClass: 'wew-class',
    colors: {
      primary: '#0065F2',
      secondary: '#F9FAFB',
      accent: '#2D3748',
    }
  },
  'wew-bdraw': {
    id: 'wew-bdraw',
    name: 'Blue Draw',
    description: 'Hand-drawn sketch style with blue-purple palette',
    bodyClass: 'wew-bdraw',
    colors: {
      primary: '#5738B8',
      secondary: '#F0F2FF',
      accent: '#2A2356',
    }
  },
  'wew-ssky': {
    id: 'wew-ssky',
    name: 'Sunset Sky',
    description: 'Urban sunset with cloudy shapes and warm colours',
    bodyClass: 'wew-ssky',
    colors: {
      primary: '#F97316',
      secondary: '#FFF1E6',
      accent: '#2D1810',
    }
  },
  // Add more themes here
  // 'wew-dark': {
  //   id: 'wew-dark',
  //   name: 'Dark Mode',
  //   description: 'Dark theme for night use',
  //   bodyClass: 'wew-dark',
  //   colors: {
  //     primary: '#F5B81C',
  //     secondary: '#1A202C',
  //     accent: '#FFFFFF',
  //   }
  // },
};

export const defaultTheme = 'wew-gold';

export const getTheme = (themeId) => {
  return themes[themeId] || themes[defaultTheme];
};

export const getStoredTheme = () => {
  if (typeof localStorage !== 'undefined') {
    return localStorage.getItem('app-theme') || defaultTheme;
  }
  return defaultTheme;
};

export const setStoredTheme = (themeId) => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('app-theme', themeId);
  }
};

export const applyTheme = (themeId) => {
  const theme = getTheme(themeId);

  // Remove all theme classes
  Object.values(themes).forEach(t => {
    document.body.classList.remove(t.bodyClass);
  });

  // Add the new theme class
  document.body.classList.add(theme.bodyClass);

  // Store the preference
  setStoredTheme(themeId);

  return theme;
};

// Initialize theme on load
export const initTheme = () => {
  const storedTheme = getStoredTheme();
  applyTheme(storedTheme);
  return storedTheme;
};
